// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"e7b2f23c","839":"d28e7063"}[chunkId] + ".chunk.js";
};